import { render, staticRenderFns } from "./paginated-crud.vue?vue&type=template&id=10f8a3e6&"
import script from "./paginated-crud.vue?vue&type=script&lang=js&"
export * from "./paginated-crud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports